import { Form } from 'components/organisms';
import { musicProductPhysicalInitialValues } from 'components/organisms/forms/music-product-physical/MusicProductPhysicalForm';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useLocation, useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteMusicProductPhysical,
  useGetMusicProductPhysical,
} from 'services/music-product-physical';
import { getMainTitle } from 'utils/global/mainTitle.utils';
import { getLastTabPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';

const MusicProductPhysical = () => {
  const musicProductPhysicalId = useParamId('music-product-physical');
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data: musicProductPhysical, isLoading } = useGetMusicProductPhysical(
    musicProductPhysicalId
  );

  const removeMusicProductPhysical = useDeleteMusicProductPhysical(
    musicProductPhysicalId
  );

  const musicProductPhysicalIndividualInitialValues = musicProductPhysical
    ? middleware.musicProductPhysical.queryToForm(musicProductPhysical)
    : musicProductPhysicalInitialValues;

  const goToEditMusicProductPhysical = () => {
    musicProductPhysical &&
      navigate(
        `/music-product-physical/edit/${musicProductPhysicalId}/${getLastTabPathname(
          pathname
        )}`,
        {
          replace: true,
        }
      );
  };

  const onRemoveMusicProductPhysical = async (actions: PopupActions) => {
    await removeMusicProductPhysical.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/music-product-physical'),
    });
  };

  return (
    <Form.MusicProductPhysical
      i18nextPrefix='music-product-physical'
      onSubmit={() => {}}
      initialValues={musicProductPhysicalIndividualInitialValues}
      tittle={getMainTitle(musicProductPhysical?.mainTitle)}
      backPath='music-product-physical'
      status={{ displayMode: true, isLoading }}
    />
  );
};

export default MusicProductPhysical;
